(function () {
	'use strict';

	const selectors = {
		section: ".featured-collection"
	};

	var FeaturedCollection = () => {
		let Slider;

		async function init() {
			Slider = await window.themeCore.utils.getExternalUtil(
				"FeaturedContentSlider"
			);
			const sections = [...document.querySelectorAll(selectors.section)];
			sections.forEach((section) => {
				const sliderOptions = {
					grabCursor: true,
					slidesPerView: 1,
					spaceBetween: 20,
					centeredSlides: true,
					breakpoints: {
						768: {
							slidesPerView: 5,
							spaceBetween: 30,
							centeredSlides: false
						}
					}
				};

				Slider(section, sliderOptions).init();
			});
		}

		return Object.freeze({
			init
		});
	};

	const action = () => {
		window.themeCore.FeaturedCollection = window.themeCore.FeaturedCollection || FeaturedCollection();

		window.themeCore.utils.register(window.themeCore.FeaturedCollection, "featured-collection");
	};

	if (window.themeCore && window.themeCore.loaded) {
		action();
	} else {
		document.addEventListener("theme:all:loaded", action);
	}

})();
